import { createSlice } from '@reduxjs/toolkit'

const getInitialState = (clientId) => {
  return {
    filterForClient: clientId,
    clientId: clientId,
    page: 1,
    pageSize: 20,
  }
}

const facilityListFilterSlice = createSlice({
  name: 'facilityListFilter',
  initialState: () => getInitialState(null),
  reducers: {
    changeSearchCriteria(state, action) {
      Object.keys(action.payload).forEach(key => {
        state[key] = action.payload[key];
      });
    },
    changeClient: (_, action) => getInitialState(action.payload),
    changePage(state, action) {
      state.page = action.payload;
    }
  },
})

export const { changeSearchCriteria, changeClient, changePage } = facilityListFilterSlice.actions
export default facilityListFilterSlice.reducer
